module.exports = __webpack_public_path__ + "3c6186a606ebf70e0e68eb1868295c05.svg";